export default __webpack_public_path__ + "static/media/icon5.e716f508.svg";